// extracted by mini-css-extract-plugin
export default {"thTable":"PatientAppointments_thTable__4-OsJ"};